import React from 'react';
import RnFEvent from './RnFEvent';
import RnFExperience from './RnFExperience';
import HorizontalSlider from './HorizontalSlider';
import VerticalSlider from './VerticalSlider';
import { shuffle } from 'utils/';

const EventCardsSlider = ({ cards, history, noslider, curatedBy }) => {
  let displayCards = [];
  cards = shuffle(cards);
  cards.map((card, i) => {
    switch (card.eventType) {
      case 'EVENT':
        displayCards.push(
          <RnFEvent
            key={'card' + i}
            name={card.experienceType.name}
            // curatedBy={card.owner.firstName + ' ' + card.owner.lastName}
            date={card.days ? card.days : ''}
            location={card.timings ? card.timings : ''}
            summary={card.description ? card.description : card.about}
            img={card.mainImage.uri ? card.mainImage.uri : '/img/na.png'}
          />
        );
        return 0;
      case 'EXPERIENCE':
        displayCards.push(
          <RnFExperience
            key={'card' + i}
            name={card.name}
            expType={card.experienceType.name}
            summary={card.description ? card.description : card.about}
            img={card.mainImage.uri ? card.mainImage.uri : '/img/na.png'}
          />
        );
        return 0;
      default:
        return 0;
    }
  });
  if (noslider) return <VerticalSlider>{displayCards}</VerticalSlider>;
  else return <HorizontalSlider>{displayCards}</HorizontalSlider>;
};

export default EventCardsSlider;
